import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getToken } from '../services/users/AuthService';
import authEvents from '../services/users/AuthEvents';

export default function PrivateRoute() {
  const token = getToken();

  useEffect(() => {
    if (!token) {
      authEvents.emit("LOGGED_OUT");
    }
  }, [token]);

  return token ? <Outlet /> : <Navigate to="/" replace />;
}